import {
  AuthError,
  AuthResponse,
  AuthTokenResponsePassword,
  OAuthResponse,
  Session,
  UserResponse,
  VerifyEmailOtpParams,
} from '@supabase/supabase-js'
import { createContext } from 'react'

import { SupabaseUserMetadata } from '@/models'
import { asyncNoop, noop } from '@/utils'

export const AuthContext = createContext<{
  jwt?: string
  userMetadata?: SupabaseUserMetadata
  isLoading: boolean
  session: Session | null | undefined
  updateToken(
    newToken: string,
    onSuccess?: () => void,
    refreshToken?: string,
  ): void
  getCurrentToken(): string | undefined
  goToInitialPage(): void
  signOut(): void
  signIn(email: string, password: string): Promise<AuthTokenResponsePassword>
  signUp(email: string, password: string): Promise<AuthResponse>
  updatePassword(password: string): Promise<UserResponse>
  resetPassword(email: string): Promise<
    | {
        data: Record<string, never>
        error: null
      }
    | {
        data: null
        error: AuthError
      }
  >
  verifyEmailOtp(
    params: Pick<VerifyEmailOtpParams, 'email' | 'token'>,
  ): Promise<AuthResponse>
  passSetupTokenHash: string | null
  setPassSetupTokenHash(tokenHash: string | null): void
  signInWithGoogle(): Promise<OAuthResponse>
  refreshSession(): Promise<void>
}>({
  jwt: undefined,
  userMetadata: undefined,
  isLoading: false,
  session: null,
  updateToken: noop,
  getCurrentToken: noop,
  goToInitialPage: noop,
  signOut: noop,
  signIn: asyncNoop,
  signUp: asyncNoop,
  updatePassword: asyncNoop,
  resetPassword: asyncNoop,
  verifyEmailOtp: asyncNoop,
  passSetupTokenHash: null,
  setPassSetupTokenHash: noop,
  signInWithGoogle: asyncNoop,
  refreshSession: asyncNoop,
})
